import '@testing-library/jest-dom';
import { render, screen, fireEvent } from '@testing-library/react';

import { MultiSelectBox } from './MultiSelectBox';

const onChangeSpy = jest.fn();

const mockSelectData = [
  { label: 'Option 1', value: '1' },
  { label: 'Option 2', value: '2' },
  { label: 'Option 3', value: '3' },
];

describe('MultiSelectBox', () => {
  it('renders the component with default props', () => {
    render(<MultiSelectBox selectData={mockSelectData} onChange={onChangeSpy} labelSuffix="selected" />);
    const button = screen.getByRole('button');
    expect(button).toBeInTheDocument();
    expect(button).toHaveAttribute('aria-expanded', 'false');
  });

  it('opens the dropdown when the button is clicked', () => {
    render(<MultiSelectBox selectData={mockSelectData} onChange={onChangeSpy} labelSuffix="selected" />);
    const button = screen.getByRole('button');
    fireEvent.click(button);
    expect(button).toHaveAttribute('aria-expanded', 'true');
    expect(screen.getByRole('listbox')).toBeInTheDocument();
  });

  it('closes the dropdown when clicking outside', () => {
    render(
      <>
        <MultiSelectBox selectData={mockSelectData} onChange={onChangeSpy} labelSuffix="selected" />
        <div data-testid="outside-element">Outside</div>
      </>
    );

    const button = screen.getByRole('button');
    fireEvent.click(button);
    expect(button).toHaveAttribute('aria-expanded', 'true');
    const outsideElement = screen.getByTestId('outside-element');
    fireEvent.click(outsideElement);
    expect(button).toHaveAttribute('aria-expanded', 'false');
  });
});
